<template>
	<div class="hint-holder">
		<div class="hint" v-bind:class="{ open: hintOpen }" @click="toggleHint()">
			<div class="hint-btn">
				<img class="hint-btn-bg" :src="game_config.hint_tab_bg" />
				<span>HINT</span>
				<svg  v-bind:class="{ open: hintOpen }" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 8 12">
					<rect y="10" width="3" height="2" fill="#000000"/>
					<rect width="3" height="2" fill="#000000"/>
					<rect x="2.5" y="2.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 7.5 -0.5)" width="3" height="2" fill="#000000"/>
					<rect x="2.5" y="7.5" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 12.5 4.5)" width="3" height="2" fill="#000000"/>
					<rect x="5" y="5" width="3" height="2" fill="#000000"/>
				</svg>
			</div>
			<div class="hint-content">
				<p v-html="currentRequest.hint"></p>
				<!--<Button :action="toggleHint">CLOSE</Button>-->
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Button from '@/components/abstract/Button';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'Hint',
	mixins: [msEdgeImageSwap],
	data() {
		return {
			hintOpen: false,
		};
	},
	components: {
		Button,
	},
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
		currentRequest() {
			return this.$store.state.gameArray[this.$store.state.level][this.$store.state.scene];
		},
	},
	methods: {
		toggleHint() {
			this.hintOpen = !this.hintOpen;
		},
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss" scoped>
.hint-holder{
	position: absolute;
	display: block;
	top: 7%;
	width: 92%;
	height: 93%;
	overflow: hidden;
	pointer-events: none;
	& .hint{
		color: black;
		height: 100%;
		pointer-events: all;
		transition: transform .5s ease-out, top .5s ease-out;
		// transform: translateY(calc(100% - 33px)); IE11 doesn't support
		transform: translateY(100%);
		top: -33px;
		@include breakpoint(xsm){
			top: -21px;
			// transform: translateY(calc(100% - 21px)); IE11 doesn't support
		}
		&.open{
			transform: translateY(0%);
			top: 0;
		}
		& .hint-btn{
			text-align: center;
			top: 1px;
			width: 90px;
			height: 34px;
			min-width: 80px;
			padding: 1% 0;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			@include breakpoint(xsm){
				width: 70px;
				height: 22px;
				font-size: 0.875em;
			}
			& .hint-btn-bg{
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
			}
			& svg{
				width: 8px;
				height: 14px;
				display: inline-block;
				margin-left:8px;
				top: 1px;
				transition: transform .5s ease-out;
				transform: rotate(-90deg);
				@include breakpoint(xsm){
					width: 6px;
					height: 10px;
				}
				&.open{
					transform: rotate(90deg);
				}
			}
		}
		& .hint-content{
			display: flex;
			flex-direction: column;
			justify-content: center;
			background-color: #f3ce77;
			height: 87%;
			width: 100%;
			padding: 0 5%;
			overflow: auto;
			p{
				width: 100%;
				height: auto;
				margin: 0 auto;
				@include breakpoint(md){
					font-size: 1em;
				}
				@include breakpoint(sm){
					font-size: 0.875em;
					line-height: normal;
					padding-bottom: 15px;
				}
			}
			button{
				margin: 15px auto 0 auto;
				@include breakpoint(sm){
					margin: 10px auto 5px auto;
				}
				@include breakpoint(xsm){
					font-size: 0.8125em;
				}
				@include breakpoint(xs){
					margin: 5px auto 5px auto;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/Hint.vue